module.exports = __webpack_public_path__ + "assets/img/deividas.031ce73e.jpg";